import api from "../auth/api";
import type { GetOverallRankResponse } from "./overall-rank.type";

// Get overall rank by symbol
export const getOverallRank = async (
  symbol: string,
  tabAccessToken?: string
): Promise<GetOverallRankResponse> => {
  const response = await api.get<GetOverallRankResponse>(
    `/overall-rank/${symbol}`,
    {
      headers: tabAccessToken
        ? { "X-Tab-Access-Token": tabAccessToken }
        : undefined,
    }
  );
  return response.data;
};

